import React from 'react';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper kl1w08gke6d-editor_css' },
  page: { className: 'home-page kl3cpu8r6n-editor_css' },
  logo: {
    className: 'header0-logo kl1vzpbpjn6-editor_css',
    children: 'https://os.alipayobjects.com/rmsportal/mlcYmsRilwraoAe.svg',
  },
  Menu: {
    className: 'header0-menu kl3cpp3rpy-editor_css',
    children: [
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/',
          children: [
            {
              children: (
                <span>
                  <p>首页</p>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>产品与服务</p>
                  </span>
                </span>
              ),
              name: 'text',
              className: 'kl3ch6c3ey-editor_css',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item kl3cx9r88x-editor_css',
              children: [
                {
                  name: 'image0',
                  className: 'item-image',
                  children:
                    'https://xhm-test.oss-cn-beijing.aliyuncs.com/xhm_img/web/xhm_tree_logo.png',
                },
                {
                  name: 'title',
                  className: 'item-title',
                  children: (
                    <span>
                      <p>个人品牌</p>
                    </span>
                  ),
                },
                {
                  name: 'content',
                  className: 'item-content',
                  children: (
                    <span>
                      <p>自媒体,带货达人</p>
                    </span>
                  ),
                },
              ],
              href: '/product#personal',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image',
                  children:
                    'https://xhm-test.oss-cn-beijing.aliyuncs.com/xhm_img/web/xhm_tree_logo.png',
                },
                {
                  name: 'title',
                  className: 'item-title',
                  children: (
                    <span>
                      <span>
                        <p>小微服务</p>
                      </span>
                    </span>
                  ),
                },
                {
                  name: 'content',
                  className: 'item-content',
                  children: (
                    <span>
                      <span>
                        <p>个体工商户,连锁店面</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/product#business',
            },
          },
          {
            name: 'sub~kl1vvq6s57',
            className: 'item-sub kl3chwdrf4-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image',
                  children:
                    'https://xhm-test.oss-cn-beijing.aliyuncs.com/xhm_img/web/xhm_tree_logo.png',
                },
                {
                  name: 'title',
                  className: 'item-title',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>跨境电商</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
                {
                  name: 'content',
                  className: 'item-content',
                  children: (
                    <span>
                      <span>
                        <p>国内外经销商,跨境物流</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/product#overseatrade',
            },
          },
        ],
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/aboutus',
          children: [
            {
              children: (
                <span>
                  <p>关于我们</p>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/contactus',
          children: [
            {
              children: (
                <span>
                  <p>联系我们</p>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner30DataSource = {
  wrapper: { className: 'banner3 kl1x7l8gn6-editor_css' },
  textWrapper: {
    className: 'banner3-text-wrapper kl1x8e75jur-editor_css',
    children: [
      {
        name: 'slogan',
        className: 'banner3-slogan kl1x7bius5-editor_css',
        children: '让用户体验互联网的美好',
        texty: true,
      },
    ],
  },
};
export const Content90DataSource = {
  wrapper: { className: 'home-page-wrapper content9-wrapper' },
  page: { className: 'home-page content9' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
        className: 'title-image',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>互联网+的时代，你是否有这样的烦恼？</p>
          </span>
        ),
        className: 'title-h1',
      },
    ],
  },
  block: {
    className: 'timeline',
    children: [
      {
        name: 'block0',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/qJnGrvjXPxdKETlVSrbe.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>个人餐馆，小吃店面等</p>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post kl3esd8zida-editor_css',
            children: '公司 职位',
          },
          time: {
            className: 'block-time kl3esiytml6-editor_css',
            children: '09:00 - 10:00',
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <p>想要做线上，又不知入驻哪个平台？</p>
                  <p>
                    <br />
                  </p>
                  <p>不同平台规则太复杂，活动经常被迫性参加</p>
                  <p>
                    <br />
                  </p>
                  <p>利润被压榨，平台抽成太心痛😢😢😢😢</p>
                </span>
              </span>
            ),
          },
          content: { className: 'block-content', children: '' },
        },
      },
      {
        name: 'block1',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>个体工商户</p>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post kl3exejd61d-editor_css',
            children: '公司 职位',
          },
          time: {
            className: 'block-time kl3exgmawf-editor_css',
            children: '09:00 - 10:00',
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <p>只做门前生意已经远远不够，想要通过互联网卖产品</p>
                  <p>
                    <br />
                  </p>
                  <p>公域流量太冷酷，在某宝上一个月都没有开单</p>
                  <p>
                    <br />
                  </p>
                  <p>会员体系，促销活动，客户关系维护？ 还要费时费力去学习</p>
                  <p>
                    <br />
                  </p>
                  <p>太难了~~</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content kl3exoecqom-editor_css',
            children:
              '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
          },
        },
      },
      {
        name: 'block2',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>小微企业管理</p>
              </span>
            ),
          },
          post: {
            className: 'block-post kl3f1gfk6vf-editor_css',
            children: '公司 职位',
          },
          time: {
            className: 'block-time kl3f1ilutmm-editor_css',
            children: '09:00 - 10:00',
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <p>客户多，订单乱，一不留神就出错</p>
                <p>
                  <br />
                </p>
                <p>尝试使用其他的办公软件，但是不符合自身的经营情况</p>
                <p>
                  <br />
                </p>
                <p>员工离职客户资源受损失，Excel表格到处飞</p>
                <p>
                  <br />
                </p>
                <p>工作效率真的低！！！</p>
              </span>
            ),
          },
          content: {
            className: 'block-content kl3f1jo0f9-editor_css',
            children:
              '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
          },
        },
      },
      {
        name: 'block3',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>跨境厂家货源供应商</p>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post kl3f40hszno-editor_css',
            children: '公司 职位',
          },
          time: {
            className: 'block-time kl3f4299j3k-editor_css',
            children: '09:00 - 10:00',
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <p>跨境贸易本是一片蓝海</p>
                <p>
                  <br />
                </p>
                <p>怎奈入行门槛太高，报关，物流，清关，配送，购买，售后</p>
                <p>
                  <br />
                </p>
                <p>每一个环节都要亲力亲为，可是我只想要</p>
                <p>
                  <br />
                </p>
                <p>把我的货卖到海外去，有这么难吗？</p>
              </span>
            ),
          },
          content: {
            className: 'block-content kl3f43fmb6s-editor_css',
            children:
              '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
          },
        },
      },
    ],
  },
};
export const Feature00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <p>我们可以做什么？</p>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>全平台产品开发</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          开发各家小程序,APP,官网商城，微信公众号等全渠道产品，开发团队人均8~10年开发经验
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>专属定制服务</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    拒绝模板，根据每位客户实际需求设计适合您的方案，因地制宜，助力您的销售与宣传
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>近乎完美的服务</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    小合木独创盈利合伙人模式，让您无需担心后期维护难，费用高的问题，近乎完美的售后服务
                  </p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Banner10DataSource = {
  wrapper: { className: 'banner1' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0' },
        title: {
          className: 'banner1-title kl20vgck8y-editor_css',
          children: (
            <span>
              <p>为什么， 我不能为自己“带盐” ？</p>
            </span>
          ),
        },
        content: {
          className: 'banner1-content kl210q0r2yb-editor_css',
          children: (
            <span>
              <p>——一位“某团”入驻商家的亲身自述</p>
            </span>
          ),
        },
        button: {
          className: 'banner1-button',
          children: (
            <span>
              <p>点击查看详情</p>
            </span>
          ),
          href: 'https://www.sohu.com/a/387543784_100069650',
          target: '_blank',
        },
      },
      {
        name: 'elem1',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1' },
        title: {
          className: 'banner1-title',
          children: (
            <span>
              <span>
                <span>
                  <p>如何让企业，</p>
                  <p>真正插上互联网的翅膀飞翔？</p>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'banner1-content',
          children: (
            <span>
              <p>
                ——来自“小合木”知乎专栏-《如何用技术简化企业工作<span>》</span>
              </p>
            </span>
          ),
        },
        button: {
          className: 'banner1-button',
          children: (
            <span>
              <p>点击查看</p>
            </span>
          ),
          href: 'https://zhuanlan.zhihu.com/',
          target: '_blank',
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 kl21b9sojbs-editor_css' },
        title: {
          className: 'banner1-title',
          children: (
            <span>
              <p>跨境电商-下一个十年，我们一起打造</p>
            </span>
          ),
        },
        content: {
          className: 'banner1-content kl21aekyg2e-editor_css',
          children: (
            <span>
              <p>——小合木跨境电商事业部为您亲情讲述</p>
            </span>
          ),
        },
        button: {
          className: 'banner1-button',
          children: (
            <span>
              <p>开启，下一个十年</p>
            </span>
          ),
          href: 'www.overseatrade.xiaohemu.net',
          target: '_blank',
        },
      },
    ],
    autoPlay: true,
    initShow: 1,
    autoPlaySpeed: 5000,
    sync: false,
  },
};
export const Feature80DataSource = {
  wrapper: { className: 'home-page-wrapper feature8-wrapper' },
  page: { className: 'home-page feature8' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature8-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature8-title-h1',
        children: (
          <span>
            <span>
              <p>我们如何服务客户？</p>
            </span>
          </span>
        ),
      },
      {
        name: 'content',
        className: 'feature8-title-content',
        children: (
          <span>
            <p>选择类型，极速响应，沟通需求，随时待命</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'feature8-button-wrapper',
    children: [
      {
        name: 'button',
        className: 'feature8-button',
        children: {
          href: '/product',
          children: (
            <span>
              <p>开始服务</p>
            </span>
          ),
          type: 'primary',
        },
      },
    ],
  },
  Carousel: {
    dots: false,
    className: 'feature8-carousel',
    wrapper: { className: 'feature8-block-wrapper' },
    children: {
      className: 'feature8-block',
      titleWrapper: {
        className: 'feature8-carousel-title-wrapper',
        title: { className: 'feature8-carousel-title' },
      },
      children: [
        {
          name: 'block0',
          className: 'feature8-block-row',
          gutter: 20,
          title: {
            className: 'feature8-carousel-title-block',
            children: '平台自主训练流程',
          },
          children: [
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child0',
              arrow: {
                className: 'feature8-block-arrow',
                children:
                  'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'image',
                    className: 'feature8-block-image',
                    children:
                      'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                  },
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <span>
                        <p>选择服务类型</p>
                      </span>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <span>
                        <p>
                          根据您自身的情况选择对应的服务类型，如果您不知道该如何选择，请联系我们获取建议
                        </p>
                      </span>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child1',
              arrow: {
                className: 'feature8-block-arrow',
                children:
                  'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'image',
                    className: 'feature8-block-image',
                    children:
                      'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                  },
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <span>
                        <span>
                          <p>极速响应</p>
                        </span>
                      </span>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <span>
                        <p>
                          小合木承诺24小时内私人客服专员会与您取得联系，沟通初步的意向需求，您也可以选择勿扰模式保护您的隐私
                        </p>
                      </span>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child2',
              arrow: {
                className: 'feature8-block-arrow',
                children:
                  'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'image',
                    className: 'feature8-block-image',
                    children:
                      'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                  },
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <span>
                        <span>
                          <p>沟通需求</p>
                        </span>
                      </span>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <span>
                        <span>
                          <p>
                            团队PM在与前者客服专员交接之后会成为您的服务专员，与您沟通具体的开发需求，并提供创意性的改善建议
                          </p>
                        </span>
                      </span>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child3',
              arrow: {
                className: 'feature8-block-arrow',
                children:
                  'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'image',
                    className: 'feature8-block-image',
                    children:
                      'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                  },
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <span>
                        <p>发布产品运行维护</p>
                      </span>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <span>
                        <p>
                          技术团队完成产品研发，测试以及部署等工作，交付给您验收通过，并为您提供一年免费的线上运行维护服务
                        </p>
                      </span>
                    ),
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  },
};
export const Pricing10DataSource = {
  wrapper: { className: 'home-page-wrapper pricing1-wrapper' },
  page: { className: 'home-page pricing1 kl1ypfv6hme-editor_css' },
  OverPack: { playScale: 0.3, className: 'pricing1-content-wrapper' },
  titleWrapper: {
    className: 'pricing1-title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>选择适合您的服务类型</p>
          </span>
        ),
        className: 'pricing1-title-h1 kl1yop9tmlt-editor_css',
      },
    ],
  },
  block: {
    className: 'pricing1-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'pricing1-block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'pricing1-block-box  kl1yxturvys-editor_css' },
          topWrapper: {
            className: 'pricing1-top-wrapper kl1ze7z0zvl-editor_css',
          },
          name: {
            className: 'pricing1-name kl1yr42w5h-editor_css',
            children: (
              <span>
                <p>Personal</p>
              </span>
            ),
          },
          money: {
            className: 'pricing1-money kl1yr4o3wdc-editor_css',
            children: (
              <span>
                <p>个人</p>
              </span>
            ),
          },
          content: {
            className: 'pricing1-content kl1yrkrmz3f-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <p>不再被各大平台复杂繁琐的规则压榨</p>
                                        <p>打造属于自己的私域流量</p>
                                        <p>我的生意我做主，活动打折我来定</p>
                                        <p>
                                          <br />
                                        </p>
                                        <p>适合各类个体工商户，连锁店面</p>
                                        <p>
                                          <br />
                                        </p>
                                        <p>只要您有想法，快点击下方按钮</p>
                                        <p>
                                          <br />
                                        </p>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          line: { className: 'pricing1-line' },
          buttonWrapper: {
            className: 'pricing1-button-wrapper',
            children: {
              a: {
                className: 'pricing1-button',
                href: '/product#personal',
                children: (
                  <span>
                    <p>开启改变</p>
                  </span>
                ),
                type: 'primary',
              },
            },
          },
        },
      },
      {
        name: 'block1',
        className: 'pricing1-block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'pricing1-block-box active' },
          topWrapper: { className: 'pricing1-top-wrapper' },
          name: {
            className: 'pricing1-name',
            children: (
              <span>
                <span>
                  <span>
                    <p>Business</p>
                  </span>
                </span>
              </span>
            ),
          },
          money: {
            className: 'pricing1-money',
            children: (
              <span>
                <p>小微企业</p>
              </span>
            ),
          },
          content: {
            className: 'pricing1-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>转型互联网+企业，打造专属品牌</p>
                        <p>人员管理，客户管理，订单管理</p>
                        <p>一目了然</p>
                        <p>销售数据，用户购买行为分析</p>
                        <p>助力您的销售业绩</p>
                        <p>
                          <br />
                        </p>
                        <p>让繁琐的工作简单化</p>
                        <p>
                          <br />
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          line: { className: 'pricing1-line' },
          buttonWrapper: {
            className: 'pricing1-button-wrapper',
            children: {
              a: {
                className: 'pricing1-button',
                href: '/product#business',
                children: (
                  <span>
                    <span>
                      <p>开启转型</p>
                    </span>
                  </span>
                ),
              },
            },
          },
        },
      },
      {
        name: 'block2',
        className: 'pricing1-block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'pricing1-block-box ' },
          topWrapper: { className: 'pricing1-top-wrapper' },
          name: {
            className: 'pricing1-name',
            children: (
              <span>
                <p>Oversea Trade</p>
              </span>
            ),
          },
          money: {
            className: 'pricing1-money',
            children: (
              <span>
                <span>
                  <p>跨境电商</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'pricing1-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>趁势而为，跟随海外贸易蓝海</p>
                        <p>提前布局，利用互联网将生意做到全球</p>
                        <p>
                          <br />
                        </p>
                        <p>适合各类国内外经销商</p>
                        <p>货源厂家以及跨境物流链</p>
                        <p>
                          <br />
                        </p>
                        <p>下一个十年，由我们一起打造</p>
                        <p>
                          <br />
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          line: { className: 'pricing1-line' },
          buttonWrapper: {
            className: 'pricing1-button-wrapper',
            children: {
              a: {
                className: 'pricing1-button',
                href: '/product#overseatrade',
                children: (
                  <span>
                    <p>开启未来</p>
                  </span>
                ),
                type: 'dashed',
              },
            },
          },
        },
      },
    ],
  },
};
export const Feature60DataSource = {
  wrapper: { className: 'home-page-wrapper feature6-wrapper' },
  OverPack: { className: 'home-page feature6', playScale: 0.3 },
  Carousel: {
    className: 'feature6-content',
    dots: false,
    wrapper: { className: 'feature6-content-wrapper' },
    titleWrapper: {
      className: 'feature6-title-wrapper',
      barWrapper: {
        className: 'feature6-title-bar-wrapper',
        children: { className: 'feature6-title-bar' },
      },
      title: { className: 'feature6-title' },
    },
    children: [
      {
        title: {
          className: 'feature6-title-text',
          children: (
            <span>
              <span>
                <p>已服务客户</p>
              </span>
            </span>
          ),
        },
        className: 'feature6-item',
        name: 'block1',
        children: [
          {
            md: 8,
            xs: 24,
            name: 'child0',
            className: 'feature6-number-wrapper',
            number: {
              className: 'feature6-number kl251f6jl2-editor_css',
              unit: {
                className: 'feature6-unit kl2537f57oj-editor_css',
                children: (
                  <span>
                    <span>
                      <p>个</p>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '116',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <span>
                    <p>个体品牌</p>
                  </span>
                </span>
              ),
            },
          },
          {
            md: 8,
            xs: 24,
            name: 'child1',
            className: 'feature6-number-wrapper',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit kl2546bwumd-editor_css',
                children: (
                  <span>
                    <span>
                      <span>
                        <p>次</p>
                      </span>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '680',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <span>
                    <p>小微企业</p>
                  </span>
                </span>
              ),
            },
          },
          {
            md: 8,
            xs: 24,
            name: 'child2',
            className: 'feature6-number-wrapper',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit kl256lpv8rs-editor_css',
                children: (
                  <span>
                    <span>
                      <p>家</p>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '36',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <span>
                    <p>跨境服务</p>
                  </span>
                </span>
              ),
            },
          },
        ],
      },
    ],
  },
};
export const Teams10DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>我们的用户反馈</p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper kl3e84cxbwf-editor_css',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:
                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <p>叶子</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>网红直播带货达人</p>
                </span>
              ),
            },
            {
              name: 'content1',
              className: 'teams1-content kl3ed42ykaa-editor_css',
              children: (
                <span>
                  <p>
                    我是某宝某音资深带货达人，由于平台壁垒导致我需要面对多个平台直播带货，非常不方便，通过朋友介绍让小合木帮我做了达人专show公众号，自此我可以将不同平台的粉丝引流到我的个人品牌中，转换率超高，也为我的粉丝们谋到了更低的厂商价格
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:
                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <p>韩国栋</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <span>
                    <p>个体工商户 一家面馆老板</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content1',
              className: 'teams1-content kl3e6xj7skn-editor_css',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        我是18年开始上的外卖服务，刚开始收益不错，但后来被各种平台规则限制，经常被迫参加一些自己都不清楚的打折促销活动，经营非常被动，利润也被大大降低。后来通过小合木做了自己的外卖小程序，现在所有的促销活动都由我自己决定，真正的能够将客单量和流量掌握在自己手中！
                      </p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:
                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <p>吴总</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>啤酒经销商</p>
                </span>
              ),
            },
            {
              name: 'content1',
              className: 'teams1-content kl3eixre7o8-editor_css',
              children: (
                <span>
                  <span>
                    <p>
                      用了小合木的服务才知道，原来企业管理可以这么简单方便，订单处理，客户关系，还有线下的代理经营，动动手指就可以将一切繁琐的事情化繁为简，让我可以有更多的精力放在拓展其他业务线上，对于企业发展来说，时间就是生命，而小合木给我们做的企业管理系统，就是在拯救企业的生命。
                    </p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright kl2acgr7u8g-editor_css',
    children: (
      <span>
        <span>©2021-2025 xiaohemu.net 版权所有</span>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
        >
          &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<span>京ICP备19006960号-1</span>
        </a>
      </span>
    ),
  },
};
